export default __webpack_public_path__ + "static/about-txt-jp-fc7808189f90fbd4ec1f3528677fb096.png";